import { IMeshRenderableComponent } from '@seddi/scene';

import { PropsDiff } from '../core/reconciler/propsDiff';
import { MeshRenderable, attachMaterial } from '../renderables/meshRenderable';
import { Scene as SceneNsEx, getResourceId } from '../scene/scene';
import { SceneReconcilerFrame } from './sceneReconcilerFrame';

const KeyMap = {
  castShadow: 'castShadow',
  isVisible: 'visible',
  receiveShadow: 'receiveShadow',
};

export const update = (
  renderable: MeshRenderable,
  nextProps: IMeshRenderableComponent,
  prevProps: IMeshRenderableComponent | undefined,
  frame: SceneReconcilerFrame,
): boolean => {
  const mesh = renderable.mesh;
  const resources = frame.resources;

  const diffProps = PropsDiff.diff(nextProps, prevProps);
  let dirty = false;

  for (const key of diffProps) {
    switch (key) {
      case 'castShadow':
      case 'isVisible':
      case 'receiveShadow': {
        mesh[KeyMap[key]] = nextProps[key];
        break;
      }
      case 'material': {
        const materialRef = nextProps.material;
        // Keep compatibility for embedded materials.
        const materialId = getResourceId(materialRef);
        if (resources.findMaterial(materialId)) {
          attachMaterial(renderable, materialId, resources);
          dirty = true;
        } else {
          const material =
            typeof materialRef === 'string'
              ? SceneNsEx.findMaterial(frame.nextScene, materialId)
              : materialRef;
          if (!resources.hasMaterialRequest(material.id)) {
            resources.loadMaterialDeferred(material);
          }
        }
        break;
      }
    }
  }

  return dirty;
};
